import React from 'react'
import { Link } from 'react-router-dom'

function FreeVersion() {
  return (
    <div className='container-freeversion'>
      <div className='title-version-container' >
<h1>Basic Versión</h1>
      </div>
<div className="service-card-promotion">
<h2 className="service-title">Basic Version</h2>
                  <p className="service-price">¡Gratis!</p>
                  <div className='container-free-title'>
                  {/* <p className='free-title'>Por tiempo limitado</p> */}
                  </div>
                  <ul className="service-benefits">
                    <li><strong>QR para pedidos en tiempo real</strong></li>
                    <li><strong>Dos lenguajes</strong></li>
                    <li><strong>Imágenes y efectos de sonido incluidos</strong></li>
                    <li ><strong>Chat para restaurante</strong></li>
                    <li><strong>Soporte en linea</strong></li>
                    <li className="not-included">Base de datos</li>
                    <li className="not-included">Pedido de mesero por parte de clientes</li>
                    <li className="not-included">Opciones de edición de menú por el dueño</li>
                    <li className="not-included">Registro de personal</li>
                    <li className="not-included">Blog para anuncios del restaurante</li>
                  </ul>
                </div>
      
                <div className='container-promotion-free'>
        <p>La versión gratuita es una muy buena forma de modernizar su restaurante a un bajo costo. para adquirir esta lo mejor sera que su establecimiento cuente con internet.

          El proceso es muy sencillo, solo debera escribirnos y responder a algunas preguntas. despues de esto debera darle el nombre de cada uno de las preparaciones de su restaurante y una foto del mismo para el correto uso de la app.
        </p>
        <p>Si desea adquirir su version gratuita vaya al enlace que aparece al inicio de la pagina. </p>
       <br></br>
        <p>Podra ver una muestra de como quedara su menu </p>
        <div>
          <Link className='whp-btn'   to="/service1/1">Aqui</Link>
          </div>

    <div className="manual-de-uso">
      <h1>Manual de Uso: Basic Versión</h1>
      <p>¡Hola! Espero que estés teniendo una excelente tarde. Mi nombre es Cristian Medina y soy el desarrollador de la app CyberCook que has adquirido o tienes pensado adquirir. A continuación, te compartiré algunos detalles importantes para que aproveches al máximo esta versión del sistema.</p>
      
      <hr />

      <h2>1. Organización de Mesas y Funcionamiento de la URL</h2>
      <p>Es importante entender cómo funciona la URL que se utiliza para cada mesa. Al adquirir tu paquete, te habrán proporcionado un enlace con el siguiente formato:</p>
      <pre>http://cookeronconnection77/service1/1</pre>
      <p>En este caso, el "1" que ves al final de la URL es el número de la mesa. Este número puede variar según cómo estén organizadas las mesas en tu restaurante. Después de la barra diagonal ("/"), puedes ingresar cualquier número o letra que identifique la mesa correspondiente.</p>
      <p>Ejemplos de URLs válidas:</p>
      <ul>
        <li>http://cookeronconnection77/service1/1</li>
        <li>http://cookeronconnection77/service1/A1</li>
        <li>http://cookeronconnection77/service1/75</li>
      </ul>
      <p>Cuando se reciba un pedido, el número de mesa que aparecerá en el panel del administrador será el mismo que el que hayas utilizado en la URL.</p>

      <hr />

      <h2>2. Instalación de Códigos QR</h2>
      <p>Los códigos QR para tus mesas deberán ser generados manualmente. Si tienes, por ejemplo, 10 o 20 mesas, necesitarás crear 10 o 20 códigos QR, dependiendo de la cantidad de mesas en tu restaurante.</p>
      <h3>Pasos para generar los códigos QR:</h3>
      <ol style={{color: "#c8102e"}}>
        <li>Dirígete a <a href="https://www.qr.io" target="_blank" rel="noopener noreferrer">Google Code Generator</a>.</li>
        <li>Una vez allí, verás una pantalla como esta. Solo deberás pegar la URL en la sección que dice “Submit URL”.</li>
        <li>El generador creará el código QR automáticamente.</li>
        <li>Repite este proceso tantas veces como sea necesario, generando un código QR para cada mesa.</li>
      </ol>
      <h3>Colocación del código QR:</h3>
      <p>Puedes colocar los códigos QR en las mesas a tu gusto. Algunas opciones incluyen:</p>
      <ul>
        <li>Colocarlos en un plástico transparente en la mesa.</li>
        <li>Usar calcomanías (adhesivos) con el código impreso.</li>
      </ul>
      <p>Esto depende de tu preferencia y lo que sea más conveniente para tu restaurante.</p>

      <hr />

      <h2>3. Interfaz de Administrador</h2>
      <p>La app está dividida en dos secciones: la parte del cliente y la parte del administrador. La sección de administrador es donde podrás gestionar y ver los pedidos. Esta sección solo es accesible desde una computadora (no es accesible desde dispositivos móviles).</p>
      
      <h3>Funciones del Administrador:</h3>
      <ul>
      <li><strong>Seguridad por Ip:</strong> Cada vez que inicies sesion en el administrador debes actualizar la ip con el boton "Actualizar Ip" esto permitira que solo las personas que esten conectadas desde tu wi-fi puedan hacer pedidos manuales.</li>
        <li><strong>Visualización de Pedidos:</strong> Cada vez que se reciba un pedido, aparecerá en la sección de "Órdenes en curso".</li>
        <li><strong>Acción sobre un Pedido:</strong> Si haces clic sobre una orden, se abrirá la vista completa de la misma en el lado izquierdo de la pantalla.</li>
      </ul>

      <h3>Botones Disponibles:</h3>
      <ul>
        <li><strong>F (Factura):</strong> Imprime la factura del pedido.</li>
        <li><strong>✔ (Completada):</strong> Marca la orden como completada.</li>
        <li><strong>X (Eliminar):</strong> Elimina la orden.</li>
      </ul>
      
      <h3>Recomendación:</h3>
      <p>Te sugerimos que, después de imprimir la factura, elimines el pedido para mantener el sistema limpio y organizado.</p>

      <hr />

      <p>Si tienes alguna duda o necesitas más información, no dudes en contactarnos. ¡Te deseo mucho éxito en tu uso de CyberCook!</p>
    </div>



        </div>

    </div>
  )
}

export default FreeVersion